import React from "react";
import { useDispatch, useSelector } from "react-redux";
import ProfilePhotoModal from "../Common/ProfilePhotoModal";
import { FETCH_USER_PROFILE_SUCCESS } from "../../Redux/Auth/actionType";

const EditProfileModal = ({ isOpen, onClose, profileImageUrl, updateProfileImage }) => {
  const dispatch = useDispatch();
  const { profile } = useSelector((state) => state.userReducer);
  return (
    <ProfilePhotoModal
      isOpen={isOpen}
      onClose={onClose}
      currentUrl={profileImageUrl}
      onUpdated={(url) => {
        updateProfileImage?.(url);
        if (profile) dispatch({ type: FETCH_USER_PROFILE_SUCCESS, payload: { ...profile, imageUrl: url } });
      }}
    />
  );
};

export default EditProfileModal;
